import React, { useEffect, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import './Slider.css';
import axios from 'axios';

function Slider() {
  const [images, setImages] = useState([]);

  useEffect(() => {
    axios
      .get('https://api.bakpoket.com/api/AdminContent/get-hero-images')
      .then(res => {
        setImages(res.data); 
      })
      .catch(err => {
        console.error('Failed to fetch slider images:', err);
      });
  }, []);

  return (
    <div className="slider-container">
      <div className="slider-wrapper">
        <Carousel fade controls={false} interval={3000} pause={false}>
          {images.map((img, index) => (
            <Carousel.Item key={index}>
              {img.merchantURL ? (
                <a
                  href={`https://${img.merchantURL}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="d-block w-100 carousel-img"
                    src={`data:image/png;base64,${img.base64}`}
                    alt={`Slide ${index + 1}`}
                  />
                </a>
              ) : (
                <img
                  className="d-block w-100 carousel-img"
                  src={`data:image/png;base64,${img.base64}`}
                  alt={`Slide ${index + 1}`}
                />
              )}
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </div>
  );
}

export default Slider;
